import { DEFAULT_SPLIT_SIZE, FALLBACK_SPLIT_SIZE } from "../splitCircuit";
import type { LumpedCircuitLimit } from "./types";

// Twice the auto-split's group size: above it, "Automatisch aufteilen" would make three circuits or more.
const LUMPED_FACTOR = 2;

export const lumpedCircuitLimit: LumpedCircuitLimit = ({ category }) =>
  ((category && DEFAULT_SPLIT_SIZE[category]) || FALLBACK_SPLIT_SIZE) * LUMPED_FACTOR;
